module.exports = __webpack_public_path__ + "img/32.5b3a9b14.jpg";